import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import {
  IUser,
  IUserAction,
  IUserStatistic,
} from "../../shared/interfaces/user/IUser";
import { requests } from "../../utils/api/api.service";
import { USER_URL } from "../../utils/api/endpoints";

export const UserService = {
  get: (pagination: IPagination): Promise<IBaseModel<IUser[]>> =>
    requests.get(USER_URL, pagination),
  getSingle: (id: number): Promise<IUser> => requests.get(`${USER_URL}/${id}`),
  create: (params: IUserAction) => requests.post(USER_URL, params),
  update: (params: IUserAction, id: number) =>
    requests.put(`${USER_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${USER_URL}/${id}`),
  getDashboard: (): Promise<IUserStatistic> =>
    requests.get(`${USER_URL}/dashboard`),
};
